export default [
    {
      path: '/sourcing-request',
      name: 'Sourcing Request',
      component: () => import(/* webpackChunkName: "sourcing" */ '@/modules/sourcing/views/SourcingRequest.vue'),
      meta: {
        title: 'Sourcing Request Form'
      }
    } 
  ]
  